function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.8882 3.28589V2.28589C14.8882 1.18132 13.9928 0.285889 12.8882 0.285889H6.88818C5.78361 0.285889 4.88818 1.18132 4.88818 2.28589V3.28589H1.88818C1.3359 3.28589 0.888184 3.7336 0.888184 4.28589C0.888184 4.83817 1.3359 5.28589 1.88818 5.28589H2.88818V16.2859C2.88818 17.9427 4.23133 19.2859 5.88818 19.2859H13.8882C15.545 19.2859 16.8882 17.9427 16.8882 16.2859V5.28589H17.8882C18.4405 5.28589 18.8882 4.83817 18.8882 4.28589C18.8882 3.7336 18.4405 3.28589 17.8882 3.28589H14.8882ZM12.8882 2.28589H6.88818V3.28589H12.8882V2.28589ZM14.8882 5.28589H4.88818V16.2859C4.88818 16.8382 5.3359 17.2859 5.88818 17.2859H13.8882C14.4405 17.2859 14.8882 16.8382 14.8882 16.2859V5.28589Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.88818 7.28589H8.88818V15.2859H6.88818V7.28589Z",
  fill: "#4979C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8882 7.28589H12.8882V15.2859H10.8882V7.28589Z",
  fill: "#4979C0"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.a4f78f33.svg";
export { ForwardRef as ReactComponent };